import { Component, input, type OnInit } from '@angular/core';
import { CrntFormControlValidationMessage } from '@essent/current-web-angular';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrackErrorDirective } from '@analytics/events';

import { RfaFormControl } from '../../../../level1';
import type { RfaCombination } from '../../RfaComponents';
import type { RfaComponentOptions } from '../../../models';
import type { RfaErrorTrackerOptions } from '../../../models/rfa-tracker-options.interface';
import { errorOptionsToConfig } from '../../../helpers/tracker-options-to-config';

interface ErrorData {
  error: string;
  msg: string;
  analytics: RfaErrorTrackerOptions;
}

@Component({
  selector: 'rfa-errors',
  standalone: true,
  templateUrl: './rfa-errors.component.html',
  styleUrls: ['./rfa-errors.component.scss'],
  imports: [
    CrntFormControlValidationMessage,
    AutomationIdDirective,
    TrackErrorDirective,
  ],
})
export class RfaErrorsComponent implements OnInit {
  public readonly control =
    input.required<RfaFormControl<any, RfaCombination>>();

  errors!: ErrorData[];

  ngOnInit(): void {
    const options = this.control().options as RfaComponentOptions;

    if (options?.errorMsgs) {
      this.errors = Object.entries(options.errorMsgs).map((entry) => {
        const [key, val] = entry;

        if (typeof val === 'string') {
          return {
            error: key,
            msg: val,
            analytics: {},
          };
        } else {
          return {
            error: key,
            msg: val.msg,
            analytics: val.analytics,
          };
        }
      });
    } else {
      this.errors = [];
    }
  }

  errorTrackConfig(error: ErrorData) {
    const options = this.control().options as RfaComponentOptions;

    return errorOptionsToConfig(error.analytics, {
      fieldName: options.label,
      description: error.msg,
    });
  }

  get hasErrors(): boolean {
    return this.control().errors !== null && this.control().touched;
  }
}
